<template>
    <div>
        <hts-form
            :rules="rules"
            class="space-y-6"
            @submit="handleUpdateUser">
            <div class="flex justify-center gap-4 mt-10">
                <div class="w-[500px] flex flex-col gap-5">
                    <hts-form-select
                        v-model="timeData.timezoneText"
                        v-model:text="timeData.timezoneText"
                        :label="$t('labels.timezone')"
                        :items="timezones"
                        :limit-items="1000"
                        filterable
                        required
                        prop="timezone"
                        name="timezone"
                        key-id="text"
                        key-label="text"
                        @change="changeTimezone" />
                    <hts-form-select
                        v-model="timeData.dateFormat"
                        v-model:text="dateFormatText"
                        :label="$t('labels.dateFormat')"
                        :items="CDateFormats"
                        filterable
                        required
                        prop="dateFormat"
                        name="dateFormat"
                        key-id="value"
                        key-label="label" />
                    <hts-form-select
                        v-model="timeData.timeFormat"
                        v-model:text="timeFormatText"
                        :label="$t('labels.timeFormat')"
                        :items="CDateTimeFormats"
                        filterable
                        required
                        prop="timeFormat"
                        name="timeFormat"
                        key-id="value"
                        key-label="label" />
                    <div class="flex flex-row gap-5 justify-end">
                        <hts-form-button
                            icon-name="hi-x-mark-icon"
                            icon-position="right"
                            color="error"
                            @click="getData">
                            {{ $t('labels.cancel') }}
                        </hts-form-button>
                        <hts-form-button
                            icon-name="hi-check-icon"
                            icon-position="right"
                            color="primary"
                            type="submit">
                            {{ $t('labels.save') }}
                        </hts-form-button>
                    </div>
                </div>
            </div>
        </hts-form>
    </div>
</template>
<script setup lang="ts">
import { $lodash } from '#imports'
import timezones from '@/data/time/offset.json'
const { $dayjs } = useNuxtApp()

const init = {
  timezone: 0 as null | number,
  dateFormat: '',
  timeFormat: '',
  timezoneText: ''
}

const timeData = ref(init)
const date = $dayjs()
const store = $store()
const dateFormatText = ref('')
const timeFormatText = ref('')

onMounted(() => {
  getData()
})

const dateFormats = ['YYYY-MM-DD', 'YY-MM-DD', 'MM/DD/YYYY', 'DD/MM/YYYY', 'MMM DD, YYYY', 'YYYY MMM, DD']

const timeFormats = ['HH:mm:ss', 'h:mm A', 'hh:mm:ss A']

const CDateFormats = computed(() => {
  return dateFormats.map((item: string) => {
    return { value: item, label: date.format(item) }
  })
})

const CDateTimeFormats = computed(() => {
  return timeFormats.map((item: string) => {
    return { value: item, label: date.format(item) }
  })
})

const rules = {
  timezone: 'required',
  dateFormat: 'required',
  timeFormat: 'required'
}

const getData = () => {
  timeData.value.timezone = store.system.timezone
  timeData.value.dateFormat = store.system.dateFormat
  timeData.value.timeFormat = store.system.timeFormat
  dateFormatText.value = date.format(timeData.value.dateFormat)
  timeFormatText.value = date.format(timeData.value.timeFormat)
  timeData.value.timezoneText = store.system.timezoneText
}

const changeTimezone = (item: any) => {
  if (Array.isArray(item)) {
    timeData.value.timezone = item[0].offset
    return
  }
  timeData.value.timezone = null
}

const handleUpdateUser = async () => {
  const api = {
    url: 'admincp/auth/user/time',
    method: 'put'
  }
  const data = await $api(api, { body: timeData.value })
  const resData: any = $lodash.get(data, 'data.value')
  if (resData?.success) {
    process.client && $toast().success($t('labels.updateSuccess'))

    store.system.timezone = timeData.value.timezone || 7
    store.system.dateFormat = timeData.value.dateFormat
    store.system.timeFormat = timeData.value.timeFormat
    store.system.timezoneText = timeData.value.timezoneText
  }
}
</script>
